import React, { Component } from 'react';
import Spinner from "../../../SHARED/components/spinner/spinner.component";
import { connect } from 'react-redux';
import Falist from 'react-icons/lib/fa/align-justify'
import Fagrid from 'react-icons/lib/fa/th-large';
import {getFestivals} from '../../../SHARED/actions/festival.actions';
import FestivalListItem from '../../../SHARED/components/festivallistitem/festivallistitem.component';
import CarouselItemFestival from "../../../SHARED/components/carousel/carouselitemfestival.component";
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';

class Festivals extends Component {

    constructor(props) {
        super(props);

        this.state = {
            view: 'grid'
        };
        this.switchView = this.switchView.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getFestivals('festival_period_value&sort_order=DESC&items_per_page=All');
    }

    componentDidMount() {
        pageViewEvent('Festivale - Cinemap',window.location.href)
     }

    switchView = ( selectedView ) => {
        this.setState({
            view: selectedView
        });
    };

    getFestivals = ()  => {        
        if(this.props.festivals.rows){
            return this.props.festivals.rows.map((card, i) => {
                if( this.state.view === 'list') {
                    return <FestivalListItem key={i} card={ card }/>
                } else {
                    return (
                        <div className="col-lg-2 col-sm-6" key={i}>
                            <CarouselItemFestival key={i} card={ card }/>
                        </div>
                    )
                }
            });
        }
    }

    handleChange = (event) => {
        if (event.target.value === 'festival_period_value'){
            this.props.getFestivals(event.target.value + '&sort_order=DESC');
        } else {
            this.props.getFestivals(event.target.value);
        }
    }
 
    render() {
        return (
            <div className="festival">
                <Helmet>
                    <title>Festivale - Cinemap</title>
                    <meta name="description" content="Aici poți vedea toate festivalele curente și cele care vor apărea!"/>
                    <link rel='canonical' href={window.location.href} />
                </Helmet>
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <div className ="col-12">
                    <div className="row order-view-widget">
                        <div className="col-6">
                            <span>Ordonează după:</span>
                            <select onChange={this.handleChange}>
                                <option value="festival_period_value">Cronologic</option>
                                <option value="title">Alfabetic</option>
                            </select>
                        </div>
                        <div className="col-6">
                            <div className="list-grid-view-switch float-right">
                                <div className="row no-gutters insider">
                                    <div className={`col-6 ${this.state.view === 'list' ? 'selectedview' : '' }` }>
                                        <Falist onClick={ () => this.switchView('list') }/>
                                    </div>
                                    <div className={`col-6 ${this.state.view === 'grid' ? 'selectedview' : ''}` }>
                                        <Fagrid onClick={ () => this.switchView('grid') }/>
                                    </div>
                                </div>
                            </div>
                            <span className="float-right view-type">Tip afișare: </span>
                        </div>
                    </div>
                    <div className="movie-results">
                        <div className="row no-gutters">
                            { this.getFestivals() }
                        </div>

                        {/* <div className="col see-more">
                            Vezi mai multe...
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    festivals: state.festival.festivals
});

export default connect(mapStateToProps, {getFestivals})(Festivals);


// WEBPACK FOOTER //
// ./src/FO/components/festivals/festivals.component.js